import { Box } from '@chakra-ui/react';
import { createElement } from 'react';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var sizes = {
  "default": {
    pt: 0,
    pr: 3,
    pb: 0,
    pl: 3
  },
  small: {
    p: 0
  },
  medium: {
    pt: 0,
    pr: 4,
    pb: 0,
    pl: 4
  },
  large: {
    pt: 0,
    pr: 5,
    pb: 0,
    pl: 5
  }
};
var _excluded = ["children", "count", "overflowCount", "dot", "size", "showZero"];

var Badge = function Badge(props) {
  var children = props.children,
      _props$count = props.count,
      count = _props$count === void 0 ? 0 : _props$count,
      _props$overflowCount = props.overflowCount,
      overflowCount = _props$overflowCount === void 0 ? 100 : _props$overflowCount,
      dot = props.dot,
      _props$size = props.size,
      size = _props$size === void 0 ? 'default' : _props$size,
      _props$showZero = props.showZero,
      showZero = _props$showZero === void 0 ? true : _props$showZero,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var text = '';
  !dot ? !showZero && count == 0 ? '' : text = count > overflowCount ? overflowCount + "+" : count : '';
  return createElement(Box, {
    position: "relative",
    display: "inline-block"
  }, createElement(Box, Object.assign({
    p: "1",
    minW: "8",
    minH: "8",
    borderRadius: "full",
    position: "absolute",
    top: "0",
    right: "0",
    bg: "corporateGrey.200",
    color: "black",
    d: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: "translate(50%, -50%)"
  }, sizes[size], rest, {
    "data-testid": "count-container-id"
  }), text), children);
};

export default Badge;